import URL from '@/api/URL';
import fetch from '@/api/fetch';

export function selectExchangeInfoList (params) {
  return fetch.post(URL.selectExchangeInfoList, params);
}
export function selectExchangeInfoDetail (params) {
  return fetch.post(URL.selectExchangeInfoDetail, params);
}

export function selectCertificateInfoList (params) {
  return fetch.post(URL.selectCertificateInfoList, params);
}

export function updateCertificate (params) {
  return fetch.post(URL.updateCertificate, params);
}

export function selectExchangeInfoFileDetail (params) {
  return fetch.post(URL.selectExchangeInfoFileDetail, params);
}



// WEBPACK FOOTER //
// ./src/api/modules/dataExchange.js